// @ts-nocheck — TODO: tipizzare quando si tocca
// ====== Dirty-guard globale ======
// Registry centralizzato di "form sporchi" (modifiche non salvate).
// Ogni vista/modal con stato editabile registra una funzione isDirty() + un label.
// Prima di:
//   - cambiare vista (router.setView)
//   - chiudere un modal
//   - chiudere la tab / refresh (beforeunload)
// l'app chiede conferma all'utente con i label dei form sporchi.

const _guards = new Map(); // key -> { isDirty: () => bool, label: string }

function registerDirtyGuard(key, isDirtyFn, label) {
  _guards.set(key, { isDirty: isDirtyFn, label });
}

function unregisterDirtyGuard(key) {
  _guards.delete(key);
}

function dirtyGuards() {
  const out = [];
  _guards.forEach((g, key) => {
    try {
      if (g.isDirty()) out.push({ key, label: g.label });
    } catch (e) {
      console.warn('dirtyGuard error', key, e);
    }
  });
  return out;
}

// Mostra il prompt di conferma. Ritorna true se l'utente accetta di
// procedere (perdendo le modifiche), false se annulla.
async function confirmIfDirty(opts = {}) {
  const dirtyOnes = dirtyGuards();
  if (!dirtyOnes.length) return true;

  const labels = dirtyOnes.map((d) => d.label);
  const ok = await confirmAction({
    level: 'warning',
    title: 'Modifiche non salvate',
    message:
      dirtyOnes.length === 1
        ? `Hai modifiche non salvate in "${labels[0]}".`
        : `Hai modifiche non salvate in ${dirtyOnes.length} maschere.`,
    details: dirtyOnes.length > 1 ? labels : ['Tutte le modifiche pendenti andranno perse.'],
    warning: 'Continuando perderai le modifiche fatte finora.',
    confirmText: opts.confirmText || 'Esci senza salvare',
    cancelText: opts.cancelText || 'Resta e salva'
  });
  return ok;
}

// Listener globale: avvisa il browser se l'utente prova a chiudere la tab
// con modifiche non salvate. Il browser mostra il proprio dialog nativo
// (non possiamo customizzarne il testo, e' standard W3C).
window.addEventListener('beforeunload', (e) => {
  const dirtyOnes = dirtyGuards();
  if (dirtyOnes.length) {
    e.preventDefault();
    // Browser legacy richiedono returnValue settato
    e.returnValue = '';
    return '';
  }
});

Object.assign(globalThis, {
  registerDirtyGuard,
  unregisterDirtyGuard,
  confirmIfDirty,
  dirtyGuards
});
export {};
